import { Routes } from '@angular/router';
import { menuPolicyGuard } from '@app/shared/guards/menu-policy.guard';
import { LayoutComponent } from '../layout/layout.component';
import { LoginComponent } from './pages/login/login.component';
import { RecoverComponent } from './pages/recover/recover.component';
import { MaintenanceComponent } from './pages/maintenance/maintenance.component';
import { Error404Component } from './pages/error404/error404.component';
import { Error500Component } from './pages/error500/error500.component';
import { ForgotComponent } from './pages/forgot/forgot.component';
import { NotAllowedComponent } from './pages/not-allowed/not-allowed.component';
import { homePolicyGuard } from '@app/shared/guards/home-policy.guard';

export const routes: Routes = [

    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: NotAllowedComponent, canActivate: [homePolicyGuard] }, // La policy fa il redirect alla prima pagina utile, se non trova niente mostra not allowed
            { path: 'userprofile', loadChildren: () => import('./users/users.module').then(m => m.UsersModule) },
            { path: 'user', loadChildren: () => import('./users/users.module').then(m => m.UsersModule), canActivate: [menuPolicyGuard] },
            { path: 'checks', loadChildren: () => import('./checks/checks.module').then(m => m.ChecksModule), canActivate: [menuPolicyGuard] },
            { path: 'commesse', loadChildren: () => import('./commesse/commesse.module').then(m => m.CommesseModule), canActivate: [menuPolicyGuard] },
            { path: 'audits', loadChildren: () => import('./audits/audits.module').then(m => m.AuditsModule), canActivate: [menuPolicyGuard] },
            { path: 'roles', loadChildren: () => import('./roles/roles.module').then(m => m.RolesModule), canActivate: [menuPolicyGuard] },
            { path: 'not-allowed', component: NotAllowedComponent },
        ]
    },

    // Not lazy-loaded routes
    { path: 'login', component: LoginComponent },
    { path: 'login/:id', component: LoginComponent },
    { path: 'forgot', component: ForgotComponent },
    { path: 'recover/:token', component: RecoverComponent },
    { path: 'renew/:token', component: RecoverComponent },
    { path: 'maintenance', component: MaintenanceComponent },
    { path: '404', component: Error404Component },
    { path: '500', component: Error500Component },

    // Not found
    { path: '**', redirectTo: '404' }

];
